import React from 'react';
import type { FreeformShape as FreeformShapeType } from '../../types';
import { lineHitPolygon } from '../../utils/hitArea';

interface FreeformShapeProps {
  shape: FreeformShapeType;
  isEditor?: boolean;
  isSelected?: boolean;
  scaledStrokeWidth?: number;
}

function pointsToPathData(points: Array<{ x: number; y: number }>): string {
  if (points.length === 0) return '';
  const parts = new Array(points.length);
  parts[0] = `M ${points[0].x} ${points[0].y}`;
  for (let i = 1; i < points.length; i++) {
    parts[i] = `L ${points[i].x} ${points[i].y}`;
  }
  return parts.join('');
}

export const FreeformShape = React.memo(function FreeformShape({ shape, isEditor, isSelected, scaledStrokeWidth }: FreeformShapeProps) {
  if (shape.points.length === 0) return null;

  const d = pointsToPathData(shape.points);

  return (
    <g data-shape-id={shape.id}>
      {isEditor && shape.points.length >= 2 &&
        shape.points.slice(0, -1).map((pt, i) => {
          const next = shape.points[i + 1];
          return (
            <polygon
              key={i}
              points={lineHitPolygon(pt.x, pt.y, next.x, next.y, 0.015)}
              fill="transparent"
              stroke="none"
              pointerEvents="fill"
              style={{ cursor: 'inherit' }}
            />
          );
        })
      }
      <path
        d={d}
        fill="none"
        stroke={shape.color}
        strokeWidth={scaledStrokeWidth ? scaledStrokeWidth * (shape.strokeWidth / 2) : shape.strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
        vectorEffect={scaledStrokeWidth ? undefined : 'non-scaling-stroke'}
        pointerEvents="none"
      />
    </g>
  );
});
